/*
 * @Autor: hansong27
 * @Email: hansong27@jd.com
 * @Description:
 * @CreateDate: Do not edit
 * @LastEditors: hansong27
 */
import { colorHttp, yunyingHttp } from "@/request/colorRequest";
import { http } from "@/request/colorRequest";

/**
 * @desc 获取saas菜单
 */
export const queryUserFavorites = (params?: any, options?: any) =>
    colorHttp.post("jxsaas.basic.app.queryUserFavorites", params);

/**
 * @desc 获取saas菜单
 */
export const saasTree = (params?: any, options?: any) =>
    http.post("/api/resource/saas/tree", params, options);

/**获取到家运营平台加密ticket */
export const getSsoTicket = () => colorHttp.post("bd.user.getSsoTicket");
/**获取达达cookie */
export const getDadaCookie = (params?: any, options?: any) =>
    yunyingHttp.post("/gateway/officer/syncLogin", params, options);
